import { BaseSignedOrder, OrderType } from "@/api/orders/types";
import { useMemo } from "react";
import useReservePrice from "./useReservePrice";

export default function useCurrentPrice(auction: BaseSignedOrder) {
  const reservePrice = useReservePrice(auction);

  return useMemo(() => {
    if (!auction) return;

    let currentPrice;

    const isReserveAuction = auction.type === OrderType.RESERVE_AUCTION;
    if (!isReserveAuction) {
      currentPrice = auction.price;
    } else {
      currentPrice = reservePrice?.raw;
    }

    return currentPrice?.toString();
  }, [auction, reservePrice?.raw]);
}
